var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("toggle-details", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var opened = ref.opened
          var toggle = ref.toggle
          return _c(
            "div",
            { staticClass: "add-ons-taxes-overview" },
            [
              _c(
                "button",
                {
                  staticClass: "add-on-activator",
                  class: { "--opened": opened },
                  attrs: {
                    "aria-label": "Toggle details",
                    "aria-expanded": opened ? "true" : "false",
                  },
                  on: {
                    click: toggle,
                    enter: toggle,
                    space: function ($event) {
                      $event.preventDefault()
                      return toggle($event)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "add-ons-taxes-overview-title" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.addOnsComponentData.AddOnsTitle) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "add-ons-taxes-overview-total" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getDisplayPrice({ price: _vm.addOnsTotalTaxes })
                        ) +
                        "\n      "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "expand-y" } }, [
                opened
                  ? _c(
                      "ul",
                      { staticClass: "addons-list" },
                      _vm._l(_vm.addOnsInCart, function (addOn, index) {
                        return _c(
                          "li",
                          { key: "addon-" + index, staticClass: "addon-item" },
                          [
                            _c("div", { staticClass: "addon-item-header" }, [
                              _c("div", { staticClass: "addon-title" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(addOn.addOnName) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "addon-total" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getDisplayPrice({
                                        price: _vm.getTotalTaxPerAddOn(addOn),
                                      })
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "addon-taxes" },
                              _vm._l(addOn.addOnTax, function (taxes, taxDate) {
                                return _c(
                                  "li",
                                  {
                                    key: "tax-" + taxDate,
                                    staticClass: "addon-tax",
                                  },
                                  [
                                    addOn.data && addOn.data.selectedAddOnDates
                                      ? [
                                          addOn.servicePricingType !==
                                          "per-stay"
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "addon-tax-date",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Date: " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            taxDate
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "addon-tax-quantity" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.addOnsComponentData
                                                .QuantityLabel
                                            ) +
                                            ": " +
                                            _vm._s(
                                              _vm.getAddOnQuantity(addOn)
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.showGuestsQuantity(addOn)
                                      ? [
                                          addOn.adultQuantity
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "addon-tax-quantity",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.addOnsComponentData
                                                          .AdultLabel
                                                      ) +
                                                      ": " +
                                                      _vm._s(
                                                        addOn.adultQuantity
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          addOn.childQuantity
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "addon-tax-quantity",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.addOnsComponentData
                                                          .ChildLabel
                                                      ) +
                                                      ": " +
                                                      _vm._s(
                                                        addOn.childQuantity
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(taxes, function (tax, taxIndex) {
                                      return _c(
                                        "div",
                                        {
                                          key: "tax-" + taxIndex,
                                          staticClass: "addon-tax-line",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "addon-tax-name" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(tax.taxLines) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "addon-tax-amount" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.getFormattedPrice(
                                                      tax.price
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }